import { FC } from 'react';
import { classnames } from '@/utils/classnames';

export interface IDividerProps extends Pick<TDivProps, 'className' | 'style'> {
  isHiddenOnDesktop?: boolean;
  isHiddenOnMobile?: boolean;
  includedWidth?: number;
  excludedWidth?: number;
  contrast?: 'low' | 'medium' | 'high';
  height?: number;
  mt?: number;
  mb?: number;
}

export const Divider: FC<IDividerProps> = ({
  isHiddenOnDesktop = false,
  isHiddenOnMobile = false,
  includedWidth,
  excludedWidth,
  contrast = 'medium',
  height = 1,
  mt,
  mb,
  className,
  style,
}) => {
  return (
    <div
      className={classnames(
        !includedWidth && !excludedWidth && 'w-full',
        isHiddenOnDesktop && 'md:hidden',
        isHiddenOnMobile && 'hidden md:!block',
        excludedWidth && 'mx-auto',
        contrast === 'low' && 'bg-gray-10',
        contrast === 'medium' && 'bg-gray-20',
        contrast === 'high' && 'bg-[#DBE1E6]',
        className
      )}
      style={{
        height,
        ...(includedWidth && { width: `calc(100% + ${includedWidth}px)` }),
        ...(includedWidth && {
          marginRight: `-${includedWidth / 2}px`,
          marginLeft: `-${includedWidth / 2}px`,
        }),
        ...(excludedWidth && { width: `calc(100% - ${excludedWidth}px)` }),
        ...(mt && { marginTop: `${mt}px` }),
        ...(mb && { marginBottom: `${mb}px` }),
        ...style,
      }}
    />
  );
};
